import { Alert, Code, Stack, Text } from '@mantine/core';
import type { FixtureDependencyDiagnostic } from '@/types/automations.ts';

type Props = {
  diagnostics?: FixtureDependencyDiagnostic[];
};

const FixtureDependencyDiagnostics = ({ diagnostics = [] }: Props) => {
  if (!diagnostics.length) {
    return null;
  }
  return (
    <Stack gap="xs" mt="xs">
      {diagnostics.map((diagnostic) => (
        <Alert
          key={`${diagnostic.code}:${diagnostic.controlling_step_id}`}
          color="yellow"
          title="Fixture dependency can be isolated"
        >
          <Stack gap={4}>
            <Text size="sm">{diagnostic.message}</Text>
            {diagnostic.suggested_input_selectors.length > 0 && (
              <Code block>
                {diagnostic.suggested_input_selectors
                  .map(
                    (selector) =>
                      `${selector.consumer_step_id}.${selector.input_group_key}[${selector.input_index}]`,
                  )
                  .join('\n')}
              </Code>
            )}
          </Stack>
        </Alert>
      ))}
    </Stack>
  );
};

export default FixtureDependencyDiagnostics;
